import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const HeroSection = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/11de11e78968ceb3a867ed44867e99ab.jpeg"
          alt="温かい介護サービス"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 sm:mb-8 leading-tight px-2">
            岡山市北区で選ばれる訪問介護サービス
          </h2>
          <p className="text-base sm:text-lg md:text-xl lg:text-2xl text-white mb-8 sm:mb-10 leading-relaxed max-w-3xl mx-auto px-4">
            ご自宅での安心・快適な生活を心を込めてサポートいたします
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 px-4">
            <a
              href="tel:086-012-3456"
              className="w-full sm:w-auto flex items-center justify-center space-x-2 bg-coral-500 text-white px-8 py-4 rounded-full hover:bg-coral-600 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer font-medium text-base"
            >
              <i className="ri-phone-line text-xl"></i>
              <span>086-012-3456</span>
            </a>
            <Link
              to="/services"
              className="w-full sm:w-auto flex items-center justify-center space-x-2 bg-white text-navy-800 px-8 py-4 rounded-full hover:bg-beige-50 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer font-medium text-base"
            >
              <span>サービス内容を見る</span>
              <i className="ri-arrow-right-line text-xl"></i>
            </Link>
          </div>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1, duration: 0.8 }}
        className="absolute bottom-8 left-1/2 transform -translate-x-1/2"
      >
        <div className="w-6 h-10 border-2 border-white/50 rounded-full flex items-start justify-center p-2">
          <motion.div
            animate={{ y: [0, 12, 0] }}
            transition={{ duration: 1.5, repeat: Infinity }}
            className="w-1.5 h-1.5 bg-white/70 rounded-full"
          />
        </div>
      </motion.div>
    </section>
  );
};

export default HeroSection;
